<template>
  <div class="super-paper"  v-pullUp="loadMore">
    <Audio ref="player" :src="mediaUrl" media-player="audioPlayer"></Audio>
    <div class="super-paper-title">
      <img :src="bannerImage" alt="">
    </div>
    <div></div>
    <div class="super-paper-main" v-for="(paperItem, listIndex) in list" :key="listIndex">
      <h1 class="super-paper-main-title">{{paperItem.date | dateUtils}}</h1>
      <ul class="super-paper-list">
        <li class="super-paper-list-item" v-for="(paper, itemIndex) in paperItem.list" :key="itemIndex">
          <PaperItem
            :isActive="itemIndex === currentIndex && parentIndex === listIndex"
            :paused="paused"
            :paperInfo="paper"
            :parentIndex="listIndex"
            :currentTime="currentTime"
            :paperIndex="itemIndex" @play="handlerClick"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import api from '@edu-fe/api'
import module from '../modules/super-paper'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import PaperItem from '../components/PaperItem'

export default {
  data () {
    return {
      currentIndex: -1,
      parentIndex: 0,
      mediaUrl: '',
      playing: false,
      paused: false,
      canPlay: false,
      currentTime: 0,
      duration: 0,
      mediaId: '',
      playTimer: null,
      recordTimer: null,
      learnLength: 0,
    }
  },
  computed: {
    ...mapState(module.name, keys(module.state())),
    ...mapGetters(module.name, keys(module.getters)),
    player () {
      return this.$refs.player
    },
    breakPoint () {
      return this.learnLength === this.duration ? 0 : this.learnLength
    }
  },
  filters: {
    dateUtils (val) {
      let currentDay = moment(new Date()).format('YYYY-MM-DD')
      return currentDay === val ? '今天' : val
    }
  },
  watch: {
    'mediaUrl' () {
      if (!this.paused) {
        this.player.pause()
      }
      window.clearInterval(this.recordTimer)
      this.currentTime = 0
      this.canPlay = false
    },

  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    // test () {
    //   this.player.currentTime += 10
    // },
    handlerClick (currentInfo, currentIndex, parentIndex) {
      const { url: currentMedia, id: mediaId, learnLength, duration } = currentInfo
      if (currentIndex === this.currentIndex && parentIndex === this.parentIndex && !this.paused) {
        return this.player.pause()
      }
      this.toBreakPoint()
      if (currentIndex === this.currentIndex && parentIndex === this.parentIndex) {
        this.play(1)
        this.paused = false
        return
      }
      this.learnLength = learnLength
      this.mediaUrl = currentMedia
      this.currentIndex = currentIndex
      this.parentIndex = parentIndex
      this.mediaId = mediaId
      this.duration = duration
      this.play()
      this.paused = false
    },
    toBreakPoint () {
      if (this.currentIndex !== -1) {
        this.setBreakPoint({
          parentIndex: this.parentIndex,
          currentIndex: this.currentIndex,
          currentTime: this.currentTime
        })
      }
    },
    play (isSame = 0) {
      this.playTimer = setInterval(() => {
        if (this.canPlay) {
          window.clearInterval(this.playTimer)
        }
        if (!isSame) {
          this.player.currentTime = this.breakPoint
        }
        this.player.play()
      }, 100)
    },
    initData (isFinished) {
      let finalSeconds = isFinished ? parseInt(this.duration) : parseInt(this.currentTime)
      return {
        chapterId: this.mediaId,
        isFinished,
        learnSeconds: 3,
        seconds: finalSeconds,
        type: 3
      }
    },
    record (isFinished) {
      let data = this.initData(isFinished)
      api.live.recordCourseProcess(data)
    }
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    // this.init()
    this.loadMore()
  },
  mounted () {
    this.player.addEventListener('play', () => {
      this.recordTimer =  setInterval(() => {
        this.record(0)
      }, 3000)
      this.playing = true
    })
    this.player.addEventListener('canplay', () => {
      // if (this.learnLength && os.system === 'ios') {
      //   this.player.currentTime = this.breakPoint
      // }
      this.canPlay = true
    })
    this.player.addEventListener('timeupdate', () => {
      this.currentTime = this.player.currentTime
    })
    this.player.addEventListener('pause', () => {
      window.clearInterval(this.recordTimer)
      this.playing = false
      this.paused = true
    })
    this.player.addEventListener('ended', () => {
      window.clearInterval(this.recordTimer)
      this.record(1)
      this.currentTime = 0
    })
  },
  directives: {
    pullUp: {
      bind (el, binding) {
        el.fn = () => {
          const scrollTop = el.scrollTop
          const scrollHeight = el.scrollHeight
          const clientHeight = document.documentElement.clientHeight
          if (scrollTop + clientHeight + 10 > scrollHeight) {
            binding.value()
          }
        }
        el.addEventListener('scroll', el.fn)
      },
      unbind (el) {
        el.removeEventListener('scroll', el.fn)
      }
    }
  },
  beforeDestroy () {
    window.clearInterval(this.recordTimer)
    window.clearInterval(this.playTimer)
    this.$store.unregisterModule(module.name)
  },
  components: {
    PaperItem
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.super-paper {
  overflow: scroll;
  height: 100vh;

  &-title {
    width: 100%;
    > img {
      width: 100%;
    }
  }
  &-main {
    padding: rem(40) rem(30);
    &-title {
      font-size: rem(36);
      font-weight: bolder;
      color: #333333;
      margin-bottom: rem(10);
    }
  }
}
</style>
